<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>

<div class="text-xl font-semibold text-gray-800 mb-5">Court / Panel Assignment</div>

<div class="bg-fieldset p-4 mb-5 rounded-lg border border-gray-200 shadow-sm" [formGroup]="searchFormGrp">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="w-full max-w-md"> <!-- Limits width to 28rem (448px) -->
  <app-case-number-search [label]="userType==='lawyer'?'Case Number':'Appeal Number'"
     (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
  </app-case-number-search>
</div>
  </div>
</div>

@if(searchedCaseNumber() && !loading()) {
<form class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-6" [formGroup]="formGrp">
  
  <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex flex-col md:flex-row md:items-center justify-between gap-4">
    <div class="flex flex-col">
      <h2 class="text-lg font-bold text-gray-800">{{caseCategoryName()}} Details</h2>
      @if (!partyDetails().loading) {
      <div class="text-primary mt-1 text-sm font-medium flex flex-wrap items-center gap-2">
        <span class="truncate max-w-[200px] md:max-w-xs" title="{{ partyDetails()[partyRoleType.APPELLANT].value.join(', ') }}">
          {{ partyDetails()[partyRoleType.APPELLANT].value ? partyDetails()[partyRoleType.APPELLANT].value.join(', ') : ''}}
        </span>
        <span class="px-2 py-0.5 bg-gray-200 text-gray-700 text-xs rounded-full font-bold">VS</span>
        <span class="truncate max-w-[200px] md:max-w-xs" title="{{ partyDetails()[partyRoleType.RESPONDENT].value.join(', ') }}">
          {{ partyDetails()[partyRoleType.RESPONDENT].value ? partyDetails()[partyRoleType.RESPONDENT].value.join(', ') : ''}}
        </span>
      </div>
      }
    </div>

    <div class="flex gap-3">
      @if (caseAssigned()) {
      <button mat-flat-button color="primary" 
        [disabled]="!judges().length"
        (click)="judges().length ? assignHandler() : null">
        <mat-icon class="mr-1">person_check</mat-icon>
        {{(trailCourtInfo()?.justiceId || trailCourtInfo()?.panelId) ? 'Reassign' : 'Assign'}}
      </button>
      <button mat-stroked-button color="warn" (click)="cancelHandler()">
        <mat-icon class="mr-1">cancel</mat-icon> Cancel
      </button>
      } @else {
      <button mat-stroked-button color="primary"
        [disabled]="(!isAssigned() && trailCourtInfo()?.cptName === 'Assigned')||editDisabled"
        (click)="(isAssigned() || trailCourtInfo()?.cptName !== 'Assigned') ? editHandler() : null">
        <mat-icon class="mr-1">edit</mat-icon> Edit
      </button>
      }
    </div>
  </div>

  <div class="p-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div class="p-3 bg-gray-50 rounded border border-gray-100">
        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{{caseCategoryName()}} Number</p>
        <p class="text-base font-medium text-gray-900 truncate" title="{{trailCourtInfo()?.courtCaseNumber}}">
          {{trailCourtInfo()?.courtCaseNumber || '-'}}
        </p>
      </div>
      <div class="p-3 bg-gray-50 rounded border border-gray-100">
        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{{caseCategoryName()}} Status</p>
        <p class="text-base font-medium text-gray-900 truncate">
          {{trailCourtInfo()?.caseStatusName || '-'}}
        </p>
      </div>
      <div class="p-3 bg-gray-50 rounded border border-gray-100">
        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{{caseCategoryName()}} Stage</p>
        <p class="text-base font-medium text-gray-900 truncate">
          {{trailCourtInfo()?.cptName || '-'}}
        </p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      
      <div>
        <mat-label>Division</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="division" (selectionChange)="divisionChangeHandler($event)">
            @for(division of divisions(); track division.courtUnitTypeId) {
            <mat-option [value]="division.courtUnitTypeId">{{division.courtUnitTypeName}}</mat-option>
            }
          </mat-select>
          <mat-error>Field value required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-label>Courts</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="court" (selectionChange)="courtChangeHandler($event)">
            @for(court of sortedCourtList; track court.courtUnitTypeId) {
            <mat-option [value]="court.courtUnitTypeId">{{court.courtUnitTypeName}}</mat-option>
            }
          </mat-select>
          <mat-error>Field value required</mat-error>
        </mat-form-field>
      </div>

      @if(trailCourtInfo()?.caseCategory === 'A' || (trailCourtInfo()?.caseCategory == caseCategoryEnum.FI && (isIstCourt())) ) {
        <div>
          <mat-label>Session</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="session" (selectionChange)="sessionChangeHandler($event)">
              @for(session of courtSessions(); track session.id) {
              <mat-option [value]="session.id">{{session.name}}</mat-option>
              }
            </mat-select>
            <mat-error>Field value required</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-label>Panel</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="panel" (selectionChange)="panelChangeHandler($event)">
              @for(panel of panels(); track panel.id) {
              <mat-option [value]="panel.id">{{panel.name}}</mat-option>
              }
            </mat-select>
            <mat-error>Field value required</mat-error>
          </mat-form-field>
        </div>
      } 
      @else {
        <ng-container *ngIf="judges().length > 0">
          
          <div>
            <ng-container *ngIf="judgeLoading; else judgeNameBlock">
              <div class="flex items-center gap-2 h-[56px] border rounded px-3 border-gray-300">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span class="text-sm text-gray-500">Loading Judges...</span>
              </div>
            </ng-container>
            <ng-template #judgeNameBlock>
              @if (judges().length === 1) {
                <div class="h-[56px] flex flex-col justify-center px-3 bg-gray-50 rounded border border-gray-200">
                   <span class="text-xs text-gray-500">Judge Name</span>
                   <span class="font-medium text-gray-800 truncate">{{ judges()[0].justiceName}}</span>
                </div>
              } @else {
                <mat-label>Judge Name</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-select formControlName="judge">
                    @for(judge of judges(); track judge.justiceId) {
                    <mat-option [value]="judge.justiceId">{{judge.justiceName}}</mat-option>
                    }
                  </mat-select>
                  <mat-error>Field value required</mat-error>
                </mat-form-field>
              }
            </ng-template>
          </div>

          <div>
            <ng-container *ngIf="judgeLoading; else judgeIdBlock">
               <div class="h-[56px] border rounded px-3 border-gray-300 bg-gray-50"></div>
            </ng-container>
            <ng-template #judgeIdBlock>
              @if (judges().length === 1) {
                <div class="h-[56px] flex flex-col justify-center px-3 bg-gray-50 rounded border border-gray-200">
                  <span class="text-xs text-gray-500">Judge ID</span>
                  <span class="font-medium text-gray-800">{{ judges()[0].justiceId}}</span>
               </div>
              } @else {
                <mat-label>Judge ID</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-select formControlName="judge">
                    @for(judge of judges(); track judge.justiceId) {
                    <mat-option [value]="judge.justiceId">{{judge.justiceId}}</mat-option>
                    }
                  </mat-select>
                  <mat-error>Field value required</mat-error>
                </mat-form-field>
              }
            </ng-template>
          </div>

        </ng-container>
      }
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4">
      
     <div class="order-2 lg:order-1">
        <mat-label>Comments</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <textarea 
            matInput 
            #commentsInput
            formControlName="comments" 
            rows="5" 
            placeholder="Enter assignment comments here..." 
            maxlength="3500">
          </textarea>
          
          <mat-hint align="end">
            {{ commentsInput.value.length }}/3500
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="order-1 lg:order-2">
        @if (trailCourtInfo()?.caseCategory == caseCategoryEnum.FI && (!isIstCourt())) {
          <div class="bg-blue-50 border border-green-100 rounded-lg p-4">
            <div class="text-sm font-semibold text-grren-800 mb-3 border-b border-green-200 pb-2">
              Case Statistics
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
              @if(judgeStatData().totalCount) {
              <div>
                <div class="text-xs text-green-600 uppercase tracking-wide">Total Count</div>
                <div class="text-xl font-bold text-green-900">{{judgeStatData().totalCount}}</div>
              </div>
              }
              @for (startItem of judgeStatData() | keyvalue; track 'msjs' + $index) {
                @if(startItem.key !== 'totalCount') {
                <div>
                  <div class="text-xs text-gray-500 uppercase tracking-wide">{{startItem.key}}</div>
                  <div class="text-sm font-medium text-gray-800">{{startItem.value}}</div>
                </div>
                }
              }
            </div>
          </div>
        } @else {
          <div>
            <div class="text-sm font-semibold text-gray-700 mb-2 pl-1">
              Panel Judges
            </div>
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <div class="overflow-x-auto">
                <table class="w-full text-sm text-left">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200">
                    <tr>
                      <th scope="col" class="px-4 py-3 font-semibold">Judge Name</th>
                      <th scope="col" class="px-4 py-3 font-semibold">Judge ID</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    @for (judge of panelJudges(); track 'mspj' + $index) {
                    <tr class="hover:bg-gray-50">
                      <td class="px-4 py-2 font-medium text-gray-900">{{ judge.justiceName }}</td>
                      <td class="px-4 py-2 text-gray-500">{{ judge.justiceId }}</td>
                    </tr>
                    } @empty {
                    <tr>
                      <td colspan="2" class="px-4 py-4 text-center text-gray-500 italic">
                        No Judges available
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  </div>
</form>

<app-case-documents [caseNumber]="searchedCaseNumber()"></app-case-documents>
}

@if(loading()) {
  <div class="flex justify-center items-center py-10">
    <lib-loader></lib-loader>
  </div>
}